/**
 * Rendering metric budgets — single source of truth for color thresholds.
 *
 * "budget" = the target maximum.  Values at or below budget are green/good;
 * values at 2× budget are red/critical.  The Areas three.js viewer and the
 * Scene Scan canvas heatmap both reference these values.
 *
 * To update a budget, change it here — both views pick it up automatically.
 */
const METRIC_BUDGETS = {
  drawCalls:  1200,
  setPass:     180,
  batches:    1200,
  triangles: 500000,
  vertices:  750000,
  shadowCasterRenderers: 100,
  candidateLights: 25,
  candidateShadowCastingLights: 8,
  transparentDraws: 200,
  opaqueDraws: 800,
  depthPrepassDraws: 400,
  mainLightShadowDraws: 300,
  additionalLightShadowDraws: 100,
  batchedDraws: 800,
  unbatchedDraws: 400,
  distinctShaderVariants: 100,
};

export default METRIC_BUDGETS;
